import * as React from 'react';
import { CustomButton, ButtonType, ModalBody, Modal, ModalSize, ModalFooter, CustomSubmitButton, Textarea, HiddenInput } from "soprasteria-ui-library";
import { useAuth } from '../../../../App';
import { GeneralDentalReferralResponseApi } from "../../../../api/GeneralDentalReferralResponseApi";
import { IGeneralDentalReferralRequestCompletion } from '../../../../models/IGeneralDentalReferral';

interface IGeneralDentalReferralRequestCompletionButton {
    generalDentalReferralId: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getGeneralDentalReferral: (id: number) => void;
}

export const GeneralDentalReferralRequestCompletionButton: React.FunctionComponent<IGeneralDentalReferralRequestCompletionButton> = ({ changeSuccessMessage, changeErrorMessage, getGeneralDentalReferral, generalDentalReferralId }) => {
    const auth = useAuth();
    const api = new GeneralDentalReferralResponseApi(auth);
    const [isRequestingCompletion, setIsRequestingCompletion] = React.useState<boolean>(false);
    const [renderForm, setRenderForm] = React.useState<boolean>(false);

    const requestCompletion = (data: IGeneralDentalReferralRequestCompletion) => {
        setIsRequestingCompletion(true);
        api.requestCompletion(data,
            () => {
                document.getElementById("close-request-completion-generalDental-referral-modal")?.click();
                getGeneralDentalReferral(generalDentalReferralId);
                changeSuccessMessage("Begäran om komplettering har skickats");
            },
            (error) => {
                changeErrorMessage(error);
            },
            () => {
                setIsRequestingCompletion(false);
            })
    }

    return (
        <>
            <CustomButton buttonType={ButtonType.general} buttonText="Begär komplettering" data-toggle="modal" data-target="#request-completion-generalDental-referral-modal" onClick={() => setRenderForm(true)} />
            <Modal header="Begär komplettering" id="request-completion-generalDental-referral-modal" modalSize={ModalSize.large}>
                {
                    renderForm ?
                        <>
                            <ModalBody>
                                 <HiddenInput name="generalDentalReferralId" value={generalDentalReferralId.toString()} />
                                <Textarea name="comment" label="Kommentar" className="mt-3" required inlineLabel />
                            </ModalBody>
                            <ModalFooter>
                                <CustomButton buttonType={ButtonType.general} buttonText="Avbryt" data-dismiss="modal" id="close-request-completion-generalDental-referral-modal" onClick={() => setRenderForm(false)} />
                                <CustomSubmitButton onButtonSubmit={requestCompletion} isLoading={isRequestingCompletion}>Skicka</CustomSubmitButton>
                            </ModalFooter>
                        </>
                        : null
                }
            </Modal>
        </>
    )
}